import { useQuery, useLazyQuery } from "@apollo/react-hooks";
import React, { useState, useEffect, Fragment } from "react";
import moment from "moment";
import { DatePicker, Button, Table, Skeleton, Select, Tooltip } from "antd";
import { Pie } from '@ant-design/charts';

import { GET_DASHBOARD_1_PERMIT_CHILD_COUNT_BY_STATUS } from "../graphql/modules";
import { warnNotify } from "../util";

const { RangePicker } = DatePicker;

export const DashboardV2D1 = () => {
      const [startDate, setStartDate] = useState('');
      const [endDate, setEndDate] = useState('');
      const [sites, setSites] = useState([]);

      const [GetDashboard1Data, { data: dashboard1Data, loading: dashboard1Loading, error: dashboard1Error }] = useLazyQuery(GET_DASHBOARD_1_PERMIT_CHILD_COUNT_BY_STATUS, {
        variables: {
          startDate: startDate,
          endDate: endDate,
          sites: sites,
        },
        fetchPolicy: "cache-and-network",
      });

      const tableColumns = [
        {
          title: 'Permit Status',
          dataIndex: 'permitStatus',
          key: 'permitStatus',
          render: (text) => <a>{text}</a>,
        },
        {
          title: 'General',
          dataIndex: 'parentGeneral',
          key: 'parentGeneral',
        },
        {
          title: 'Tool Install',
          dataIndex: 'parentToolInstall',
          key: 'parentToolInstall',
        },
        {
            title: 'Child Permit',
            dataIndex: 'childPermit',
            key: 'childPermit',
          },
      ];

      const pieData = [
        {
          "permitStatus": "Pending PM Approval",
          "count": 0
        },
        {
          "permitStatus": "Pending Individual Reviewer Approval",
          "count": 0
        },
        {
          "permitStatus": "Pending MTGroup Approval",
          "count": 0
        },
        {
          "permitStatus": "Approved",
          "count": 0
        },
        {
          "permitStatus": "Pending Closure",
          "count": 0
        },
        {
          "permitStatus": "Cancelled",
          "count": 0
        },
        {
          "permitStatus": "Completed",
          "count": 0
        },
        {
          "permitStatus": "Rejected",
          "count": 0
        }
      ];
      const pieConfig = {
        forceFit: true,
        angleField: 'count',
        colorField: 'permitStatus',
        radius: 0.8,
        angleField: 'count',
        colorField: 'permitStatus',
        label: {
            text: 'count',
            style: {
              fontWeight: 'bold',
            },
        },
        legend: {
            color: {
              title: false,
              position: 'right',
              rowPadding: 5,
            },
          },
      };

      const handleDateFrom = (dates, dateStrings) => {
        if (dates) {
          const formattedDates = dates.map(date => date.format('YYYY-MM-DD'));
          console.log(formattedDates);
          setStartDate(formattedDates[0]);
          setEndDate(formattedDates[1]);
        } else {
          console.log('No dates selected');
        }
  };
      const handleSiteChange = (value) => {
          setSites(value);
      };

      const handleSubmitStartEndDates = () => {
        console.log('Start Date: ', startDate);
        console.log('End Date: ', endDate);
        console.log('sites: ', sites);
        if(startDate !== '' && endDate !== '' && sites.length > 0) {
          GetDashboard1Data();
        }
        if(startDate === '' || endDate === '') {
          warnNotify('Please select a date range');
        }
        if(sites.length === 0) {
          warnNotify('Please select atleast one site');
        }
      }

    return (
        <Fragment>
            <div className="row dec-row">
                <div className="card">
                <div className="col-12 col-md-12">
                    <div className="col-12 col-md-12 text-left">
                        <h4 className="text-left">Parent and Child Permit Count by Status</h4>
                    </div>
                    <div className="row dec-row">
                        <div className="col-3 col-md-3">
                          <RangePicker
                            style={{ width: "100%" }}
                            id={{
                              start: 'startInput',
                              end: 'endInput',
                            }}
                            onChange={handleDateFrom}
                          />
                        </div>
                        <div className="col-3 col-md-3">
                          <Select
                            mode="multiple"
                            allowClear
                            placeholder="Please select site(s)"
                            style={{
                                width: '100%',
                            }}
                            onChange={handleSiteChange}
                            maxTagCount="responsive"
                            maxTagPlaceholder={(omittedValues) => (
                                <Tooltip
                                styles={{
                                    root: {
                                    pointerEvents: 'none',
                                    },
                                }}
                                title={omittedValues.map(({ label }) => label).join(', ')}
                                >
                                <span>...</span>
                                </Tooltip>
                            )}
                            options={
                                [
                                    {
                                        value: "604a288405a8ed2d4d4bba4b",
                                        label: "Fab 10A1",
                                    },
                                    {
                                        value: "604a286b05a8ed2d4d4bba4a",
                                        label: "Fab 10A2",
                                    },
                                    {
                                        value: "604a28bb05a8ed2d4d4bba4c",
                                        label: "Fab 10N",
                                    },
                                    {
                                        value: "60cafd5a4e8783df2ab8afff",
                                        label: "Fab 10NX",
                                    },
                                    {
                                        value: "6052a5b7be761a25aaec1bd1",
                                        label: "Fab 10W",
                                    },
                                    {
                                        value: "604a28ee05a8ed2d4d4bba4e",
                                        label: "Fab 10X",
                                    }
                                ]
                            }
                        />
                        </div>
                        <div className="col-3 col-md-3">
                            <Button
                                style={{
                                    width: '100%',
                                }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleSubmitStartEndDates();
                                }}
                            >
                                Submit
                            </Button>
                        </div>
                    </div>
                    <br />
                    <div className="row dec-row">
                        <div className="col-12 col-md-12">
                            <div className="col-6 col-md-6">
                                <div className="card">
                                    <Table pagination={false} columns={tableColumns} dataSource={dashboard1Data ? dashboard1Data.GetPermitChildCountByStatus.results.tableData : []} loading={dashboard1Loading} />
                                </div>
                            </div>
                            
                            <div className="col-6 col-md-6">
                                <div className="card">
                                      <Pie {...pieConfig}
                                        data={dashboard1Data ? dashboard1Data.GetPermitChildCountByStatus.results.pieChartData : pieData}
                                        loading={dashboard1Loading}
                                      />
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </Fragment>
    )
}